import React from 'react';
import "../index.css"
import { FaFacebook } from 'react-icons/fa';
import { FaTwitter } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { FaYoutube } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';
import { FaMailBulk } from 'react-icons/fa';
import { FaLocationArrow } from 'react-icons/fa';
import { BsTelephone } from 'react-icons/bs';
import { BsPhone } from 'react-icons/bs';


const Footer = () => {
    return (
        <div>
            <div className='footer-container'>
                <h2 className="text-center font-bold text-2xl mb-10 ">Enjoy your Student Life at The New College</h2>
                <div className='space'>
                    <div>
                    </div>
                </div>

                <div className='first-foot-sec'>
                    <div className='foot'>
                        <h3>About Us</h3>
                        <div className='space'>
                            <div>
                            </div>
                        </div>
                        <p>Academic Staff</p>
                        <p>Scholarship</p>
                        <p>Admission Procedure</p>
                        <p>Managing Committee</p>
                    </div>

                    <div className='foot'>
                        <h3>Services</h3>
                        <div className='space'>
                            <div>
                            </div>
                        </div>
                        <p>College Directory</p>
                        <p>Student Development Center</p>
                        <p>Students Counselling</p>
                        <p>Students Council</p>
                        <p>Students Affairs</p>
                        <p>Hostel</p>
                        <p>Grievance Redressal</p>
                    </div>

                    <div className='foot'>
                        <h3>Learning Resources</h3>
                        <div className='space'>
                            <div>
                            </div>
                        </div>
                        <p>Open Online Learning & Certifications</p>
                        <p>Online DictionariesStudent Development Center</p>
                        <p>Open Source Journals</p>
                        <p>A Reservoir of Indian Thesis</p>
                        <p>Indian Research In Progress</p>
                        <p>Online References</p>
                        <p>N - List Inflibnet</p>
                    </div>


                    <div className='foot'>
                        <h3>Related links</h3>
                        <div className='space'>
                            <div>
                            </div>
                        </div>
                        <p>University Grants Commission</p>
                        <p>Anti Ragging</p>
                        <p>Indira Gandhi National Open University</p>
                        <p>University of Madras</p>
                        <p>Sakshat</p>
                        <p>Ministry of Human Resource Development</p>
                        <p>CSIR</p>
                    </div>


                    <div className='foot'>
                        <h3>NAAC</h3>
                        <div className='space'>
                            <div>
                            </div>
                        </div>
                        <p>IIQA</p>
                        <p>SSR - 4th Cycle</p>
                        <p>List of Programs in IIQA</p>
                        <p>Regulatory Approvals 2021-22</p>
                        <p>Regulatory Approvals 2022-23</p>
                        <p>Regulatory Approvals 2023-24</p>

                    </div>
                </div>
                <div className='space'>
                    <div>
                    </div>
                </div>

                <div className='line'></div>

                <div className='space'>
                    <div>
                    </div>
                </div>

                <div className='img-foot'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' />
                    <div>
                        <div className='foot-details'>
                            <BsPhone size={25} color='#0c4da2' />
                            <h3>(+91)-44-2835 1269</h3>
                        </div>
                        <div className='foot-details'>
                            <BsPhone size={25} color='#0c4da2' />
                            <h3> (+91)-44-2835 0386</h3>
                        </div>
                        <div className='foot-details'>
                            <FaLocationArrow size={25} color='#0c4da2' />
                            <div>
                                <h3> The New College </h3>
                                <h3> New No. #147, Old No. #87,
                                    Peter's Road,</h3>
                                <h3>
                                    Royapettah
                                    Chennai - 600 014</h3>
                            </div>

                        </div>
                        <div className='foot-details'>
                            <FaMailBulk size={25} color='#0c4da2' />
                            <h3> thenewcollege600014@gmail.com</h3>
                        </div>
                    </div>

                    <div>
                        <div className='foot-details'>
                            <FaFacebook size={25} color='#0c4da2' />
                            <h3>FaceBook</h3>
                        </div>
                        <div className='foot-details'>
                            <FaInstagram size={25} color='#0c4da2' />
                            <h3> Instagram</h3>
                        </div>
                        <div className='foot-details'>
                            <FaTwitter size={25} color='#0c4da2' />
                            <h3> Twitter</h3>
                        </div>
                        <div className='foot-details'>
                            <FaYoutube size={25} color='#0c4da2' />
                            <h3>Youtube</h3>
                        </div>
                        <div className='foot-details'>
                            <FaLinkedin size={25} color='#0c4da2' />
                            <h3>Linkedin</h3>
                        </div>
                    </div>

                </div>

                <div className='space'>
                    <div>
                    </div>
                </div>

                <div className='end-footer'>
                    <h3>Copyright © 2024 - All Rights Reserved - The New College</h3>
                     <h3>Design & Developed by Stellar Edge.</h3>
                </div>
            </div>
        </div>
    );
}

export default Footer;
